/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { ocultarAcoes } from "../../../services/acesso";
import api from "../../../services/api";
import { Typography } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import Tooltip from '@mui/material/Tooltip';
import asaasLogo from "../../../assets/asaas.png";
import { FiTruck, FiUser } from "react-icons/fi";
import { useAppSelector } from "../../../store/hooks";
import { confirm } from "../../../components/confirm";
import ModalForm from "../../../components/modal-form";
import { OverlayTrigger } from "react-bootstrap";
import { TipoFormulario } from "../../../services/constantes";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import ListagemLancamento, { AcaoEmLote, ConfiguracaoFiltros, FiltroDropdownOpcao } from "../../../components/listagem-lancamentos";
import { FaCarSide, FaCheckDouble, FaEye, FaFileAlt, FaFileInvoice, FaInfo, FaLayerGroup, FaLink, FaMotorcycle, FaCheck, FaQrcode, FaTimesCircle, FaEdit, FaTrash } from "react-icons/fa";
import { ehPlanoGratuito, estaEmPeriodoDeTeste, obterEhAdmin, obterIdTenent, obterIdUsuario, obterNomeEmpresa, usuarioTemPermissao } from "../../../services/seguranca";
import { LIMITE_DOCUMENTOS_EM_LOTE, PixFatura, comPixUnico, faturaDeLancamento, idsDistintos, lancamentosFaturaveis, unificarPorCliente, valorEmAbertoDaFatura } from "../../../components/fatura/fatura-dados";
import { gerarPdfFaturas } from "../../../components/fatura/fatura-pdf";
import { carregarEmpresaDoToken, carregarLocacoesPorId, carregarPixDosLancamentos, carregarPixPorValor } from "../../../components/fatura/documentos-lote";
import { abrirPdfNoVisualizador, carregarLogoDaEmpresa } from "../../../components/pdf/abrir-pdf";
import { converterTipoLancamentoParaTexto, converterTipoStatusLancamentoParaTexto, formatarParaReais } from "../../../services/utilitarios";
import { diaInicialDepoisDoFinal } from "../../../services/utilitarios";
import { AcaoLoteLancamento, MENSAGEM_SEM_LANCAMENTOS_NA_TABELA, idsDasLinhasExibidas, mensagemSemLancamentosParaAcao } from "./loteLancamentos";
import { ApiError, Banco, Campo, Categoria, ContextoLancamento, Lancamento, Locacao, Opcao, OpcoesPeriodicidadePagamento, TipoLancamento, TipoPeriodicidadePagamento, TipoStatusLancamento, Veiculo, StatusPagamento } from "../../../services/tipos";
import { ModalConfirmacaoLote } from "../../../components/modal-confirmacao-lote";
import { ModalAjusteValorLote } from "../../../components/modal-ajuste-valor-lote";
import { useFiliais } from "../../../hooks/useFiliais";
import DecimalMonetario from "../../../components/decimal";

// Valores em R$ calculados a partir do percentual digitado, só para mostrar (como na locação).
// Ficam no módulo para que a referência do componente seja estável e o campo não remonte a cada tecla.
const numeroDoForm = (v: any) => Number(String(v ?? 0).replace(',', '.')) || 0;
const campoMonetarioCalculado = (calcular: (entidade: any) => number) =>
    ({ campo, entidade }: { campo: any; entidade?: any }) => (
        <DecimalMonetario
            getFieldValue={() => Math.round(calcular(entidade) * 100) / 100}
            handleInputChange={() => { }}
            campo={{ nome: campo.nome, tipo: "monetario", required: false, modo: TipoFormulario.tpVisualizacao }}
            apenasLeitura={true}
        />
    );
const ValorJurosAoMesCalculado = campoMonetarioCalculado(e => numeroDoForm(e?.valor) * numeroDoForm(e?.jurosAoMes) / 100);
const ValorMultaCalculado = campoMonetarioCalculado(e => numeroDoForm(e?.valor) * numeroDoForm(e?.multaPercentual) / 100);

function LancamentoListagem() {
    const { empresaTemFiliais, filiaisOptions, filialSelecionada, getCampoFilial, labelComFilial } = useFiliais();
    const [buscar, setBuscar] = useState<boolean>(true);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [veiculos, setVeiculos] = useState<Opcao[]>([]);
    const [locacoes, setLocacoes] = useState<Locacao[]>([]);
    const [locacoesOp, setLocacoesOp] = useState<Opcao[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [categorias, setCategorias] = useState<Categoria[]>([]);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const isAdmin = obterEhAdmin(token);
    const [usuariosEmpresa, setUsuariosEmpresa] = useState<{ id: string; nome: string }[]>([]);
    const [lancamentos, setLancamentos] = useState<Lancamento[]>([]);
    const [veiculosLista, setVeiculosLista] = useState<Veiculo[]>([]);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [imagemRemovida, setImagemRemovida] = useState<boolean>(false);
    const [arquivoRemovido, setArquivoRemovido] = useState<boolean>(false);
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [categoriasEscolhidas, setCategoriasEscolhidas] = useState<any[]>([]);
    const [locacaoSelecionada, setLocacaoSelecionada] = useState<boolean>(false);
    const [habilitarCamposRepeticao, setHabilitarCamposRepeicao] = useState(false);
    const [categoriasSelecionadas, setCategoriasSelecionadas] = useState<any[]>([]);
    const [lancamentoAtualizacao, setLancamentoAtualizacao] = useState<any>({} as any);
    const [forcarAtualizacaoGrid, setForcarAtualizacaoGrid] = useState<boolean>(false);
    const [lancamentoForcarAtualizacao, setLancamentoForcarAtualizacao] = useState<boolean>(false);
    const [lancamentoSelecionado, setLancamentoSelecionado] = useState<Lancamento>({} as Lancamento);
    const [filtros, setFiltros] = useState({
        dataInicio: null as Date | null,
        dataFim: null as Date | null,
        status: TipoStatusLancamento.Todos,
        tipo: TipoLancamento.Todos
    });
    const [integradoAsaas, setIntegradoAsaas] = useState<boolean>(false);
    const [mexeuNasCategorias, setMexeuNasCategorias] = useState<boolean>(false);
    const [tipoLancamento, setTipoLancamento] = useState<TipoLancamento>(TipoLancamento.Nenhum);
    const [statusEscolhido, setStatusEscolhido] = useState<TipoStatusLancamento>(TipoStatusLancamento.Nenhum);
    const [dataDeVencimento, setDataDeVencimento] = useState();
    const [mostrarAvancadoLancamento, setMostrarAvancadoLancamento] = useState(false);
    const [bancosLancamentoOpcoes, setBancosLancamentoOpcoes] = useState<{ label: string; valor: string }[]>([]);

    // Novos Estados para Filtros Avançados e Ações em Lote
    const [lancamentosFiltrados, setLancamentosFiltrados] = useState<Lancamento[]>([]);
    const [idsLote, setIdsLote] = useState<string[]>([]);
    const [filtrosAvancados, setFiltrosAvancados] = useState({
        idLocacao: "",
        idLocatario: "",
        idVeiculo: "",
        idsCategorias: [] as string[]
    });

    const [locacoesFiltroOp, setLocacoesFiltroOp] = useState<FiltroDropdownOpcao[]>([]);
    const [locatariosFiltroOp, setLocatariosFiltroOp] = useState<FiltroDropdownOpcao[]>([]);
    const [veiculosFiltroOp, setVeiculosFiltroOp] = useState<FiltroDropdownOpcao[]>([]);
    const [categoriasFiltroOp, setCategoriasFiltroOp] = useState<FiltroDropdownOpcao[]>([]);

    const [filialNoForm, setFilialNoForm] = useState<string | null>(null);
    const [showModalLote, setShowModalLote] = useState(false);
    const [showModalAjuste, setShowModalAjuste] = useState(false);
    const [dadosLote, setDadosLote] = useState<any[]>([]);
    const [acaoLote, setAcaoLote] = useState<'baixar' | 'cancelar' | 'excluir'>('baixar');

    useEffect(() => {
        const fetchConfiguracaoEmpresa = async () => {
            await api.get('ConfiguracaoFilial/ResolvidaAtual').then((res) => {
                const config = res.data;
                if (config.asaasConfigurado) {
                    setIntegradoAsaas(true);
                } else {
                    setIntegradoAsaas(false);
                }
            }).catch((error) => {
                tratarErro(error);
            })
        }

        fetchConfiguracaoEmpresa();
    }, [])

    useEffect(() => {
        api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=true`)
            .then(r => setBancosLancamentoOpcoes(r.data.map((b: Banco) => ({ label: b.apelido, valor: b.id }))))
            .catch(() => setBancosLancamentoOpcoes([]));
    }, [token]);

    useEffect(() => {
        api.get(`/UsuarioPorEmpresa/${obterIdTenent(token)}`)
            .then(r => setUsuariosEmpresa(r.data))
            .catch(() => setUsuariosEmpresa([]));
    }, [token]);

    useEffect(() => {
        if (exibirFormModal && lancamentoSelecionado?.id) {
            const categoriasSelecionadas = lancamentoSelecionado.lancamentoCategorias?.map((lancamentoCategoria: any) => ({
                id: lancamentoCategoria.categoria.id,
                nome: lancamentoCategoria.categoria.nome,
                descricao: lancamentoCategoria.categoria.descricao,
                cor: lancamentoCategoria.categoria.cor
            })) || [];

            setCategoriasSelecionadas(categoriasSelecionadas);
            setCategoriasEscolhidas(categoriasSelecionadas);
            setMexeuNasCategorias(false);
        } else if (!exibirFormModal) {
            setCategoriasSelecionadas([]);
            setCategoriasEscolhidas([]);
            setMexeuNasCategorias(false);
        }
    }, [lancamentoSelecionado, exibirFormModal]);

    // Aplicação dos Filtros Avançados (Client-Side)
    useEffect(() => {
        if (!lancamentos) {
            setLancamentosFiltrados([]);
            return;
        }

        let resultado = [...lancamentos];

        if (filtrosAvancados.idLocacao) {
            resultado = resultado.filter(l => l.idLocacao === filtrosAvancados.idLocacao);
        }

        if (filtrosAvancados.idLocatario) {
            // Filtra lancamentos cuja locacao pertence ao locatario selecionado (mapa locacao -> locatario).
            resultado = resultado.filter(l => {
                if (!l.idLocacao) return false;
                const loc = locacoes.find((x: any) => x.id === l.idLocacao);
                return !!loc && (loc.idLocatario === filtrosAvancados.idLocatario || loc.locatario?.id === filtrosAvancados.idLocatario);
            });
        }

        if (filtrosAvancados.idVeiculo) {
            resultado = resultado.filter(l => l.idVeiculo === filtrosAvancados.idVeiculo);
        }

        if (filtrosAvancados.idsCategorias && filtrosAvancados.idsCategorias.length > 0) {
            resultado = resultado.filter(l => {
                if (!l.lancamentoCategorias || l.lancamentoCategorias.length === 0) return false;
                // Verifica se alguma categoria do lançamento está nos IDs selecionados
                return l.lancamentoCategorias.some(lc => filtrosAvancados.idsCategorias.includes(lc.idCategoria));
            });
        }

        setLancamentosFiltrados(resultado);
    }, [lancamentos, filtrosAvancados, locacoes]);

    const colunas = [
        {
            field: 'categoria',
            headerName: 'Categoria',
            flex: 1,
            renderCell: (params: any) => {
                const lancamentoCategorias = params.row.lancamentoCategorias || [];

                if (lancamentoCategorias.length === 0) {
                    return null;
                }

                const temDoisOuMais = lancamentoCategorias.length > 1;
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', width: '100%', }}>
                        {lancamentoCategorias.map((item: any) => {
                            const categoria = item.categoria;
                            if (!categoria) return null;

                            const style: React.CSSProperties = {
                                backgroundColor: categoria.cor,
                                color: 'white',
                                padding: temDoisOuMais ? '0px 1px' : '5px 10px',
                                borderRadius: '5px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                width: '100%',
                                maxWidth: '150px',
                                cursor: 'pointer'
                            };

                            return (
                                <div
                                    key={item.id}
                                    style={style}
                                    title={categoria.descricao}
                                >
                                    {categoria.nome}
                                </div>
                            );
                        })}
                    </div>
                );
            },
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            flex: 2,
            renderCell: (params: any) => {
                const locacao = params.row.idLocacao
                    ? locacoes.find((l) => l.id === params.row.idLocacao)
                    : null;

                const locatario = locacao?.locatario;
                const veiculo = locacao?.veiculo || params.row.idVeiculo ? veiculosLista.find((v) => v.id == params.row.idVeiculo) : null;

                const getVehicleIcon = () => {
                    switch (Number(veiculo?.tipoVeiculo)) {
                        case 1: return <FaCarSide size={16} />;
                        case 2: return <FaMotorcycle size={16} />;
                        case 3: return <FiTruck size={16} />;
                        default: return <FaCarSide size={16} />;
                    }
                };

                const veiculoLabel = veiculo
                    ? `${veiculo.placa}: ${veiculo.marca} ${veiculo.modelo}`
                    : '';

                const hasInfo = locatario || veiculo;

                const isShortText = (params.value || '').length <= 30;

                return (
                    <Box display="flex" flexDirection="column" py={0.5}>
                        {/* Locatário - exibe apenas se existir */}
                        {locatario && (
                            <Box display="flex" alignItems="center" gap={1}>
                                <FiUser size={16} />
                                <Typography variant="body2">{locatario.nome}</Typography>
                            </Box>
                        )}

                        {/* Veículo - exibe apenas se existir */}
                        {veiculo && (
                            <Box display="flex" alignItems="center" gap={1} mt={locatario ? 0.5 : 0}>
                                {getVehicleIcon()}
                                <Typography variant="body2">{veiculoLabel}</Typography>
                            </Box>
                        )}

                        {/* Descrição */}
                        <Box display="flex" alignItems="center" gap={1} mt={hasInfo ? 0.5 : 0}>
                            {hasInfo ? (
                                isShortText ? (
                                    <Typography variant="body2">{params.value}</Typography>
                                ) : (
                                    <Tooltip title={params.value || ''}>
                                        <Box display="flex" alignItems="center" gap={0.5} sx={{ cursor: 'pointer' }}>
                                            <FaEye size={16} />
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: '#1F467E',
                                                    textDecoration: 'underline',
                                                    '&:hover': {
                                                        color: '#1F467E'
                                                    }
                                                }}
                                            >
                                                VER DESCRIÇÃO
                                            </Typography>
                                        </Box>
                                    </Tooltip>
                                )
                            ) : (
                                <Typography variant="body2">{params.value}</Typography>
                            )}

                            {/* Tag [ORIGINAL] */}
                            {params.row.ehLancamentoOriginal && (
                                <Box
                                    component="span"
                                    sx={{
                                        backgroundColor: '#e0f7fa',
                                        padding: '1px 4px',
                                        borderRadius: '4px',
                                        fontWeight: 'bold',
                                        color: '#1F467E',
                                        ml: 1,
                                    }}
                                >
                                    {isMobile ? "[ORI]" : "[ORIGINAL]"}
                                </Box>
                            )}
                        </Box>
                    </Box>
                );
            },
        },
        {
            field: 'valor',
            headerName: 'Valor',
            flex: 1,
            renderCell: (params: any) => {
                const tipo = params.row.tipo;
                const valor = Number(params.value);
                const isEntrada = tipo === TipoLancamento.Entrada;
                const valorFormatado = formatarParaReais(valor);

                const containerStyle: React.CSSProperties = {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: isMobile ? 'flex-start' : 'flex-end',
                    paddingRight: '16px'
                };

                const valueStyle: React.CSSProperties = {
                    color: isEntrada ? '#4CAF50' : '#EF4444',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    position: 'relative',
                    paddingLeft: '20px'
                };

                const iconStyle: React.CSSProperties = {
                    position: 'absolute',
                    left: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    fontSize: '1rem'
                };

                return (
                    <div style={containerStyle}>
                        <span style={valueStyle}>
                            {isEntrada ? (
                                <span style={{ ...iconStyle, color: '#4CAF50' }}>↑</span>
                            ) : (
                                <span style={{ ...iconStyle, color: '#EF4444' }}>↓</span>
                            )}
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography>
                                    {valorFormatado}
                                </Typography>
                                {params.row.asaasPaymentId && (
                                    <Tooltip title="Integrado ao Asaas" arrow>
                                        <img
                                            src={asaasLogo}
                                            alt="Asaas"
                                            style={{ width: 18, height: 18, objectFit: "contain", cursor: "pointer" }}
                                        />
                                    </Tooltip>
                                )}
                            </Box>
                        </span>
                    </div>
                );
            }
        },
        {
            field: 'dataPagamentoFoiFeito',
            headerName: 'Data Pagamento',
            flex: 1,
            valueGetter: (params: any) => {
                return new Date(params.value);
            },
            renderCell: (params: any) => {
                const date = new Date(params.value);
                return isNaN(date.getTime())
                    ? ''
                    : date.toLocaleString("pt-BR", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                    });
            }
        },
        {
            field: 'dataRealizado',
            headerName: 'Data Vencimento',
            flex: 1,
            valueGetter: (params: any) => {
                return new Date(params.value);
            },
            renderCell: (params: any) => {
                const status = params.row.status;
                const isResolvido = status == TipoStatusLancamento.Resolvido;
                const isPendente = status == TipoStatusLancamento.Pendente;
                const isVencido = new Date() > new Date(params.value) && isPendente;

                const date = new Date(params.value);
                if (isNaN(date.getTime())) {
                    return '';
                }

                const formattedDate = date.toLocaleString("pt-BR", {
                    day: "2-digit",
                    month: "2-digit",
                    year: "numeric",
                });

                const renderTooltip = (props: any, text: string) => (
                    <Tooltip {...props}>
                        {text}
                    </Tooltip>
                );

                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        justifyContent: 'space-between',
                        paddingRight: '16px'
                    }}>
                        <span style={{
                            fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
                            fontSize: '0.875rem'
                        }}>
                            {formattedDate}
                        </span>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            {isResolvido && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={(props) => renderTooltip(props, "Resolvido (" + new Date(params.row.dataPagamentoFoiFeito).toLocaleString("pt-BR", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                    }) + ")")}
                                >
                                    <div style={{
                                        backgroundColor: '#ECFDF5',
                                        borderRadius: '50%',
                                        width: '24px',
                                        height: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="#10B981"
                                        >
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                        </svg>
                                    </div>
                                </OverlayTrigger>
                            )}
                            {isPendente && !isVencido && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={(props) => renderTooltip(props, "A Vencer")}
                                >
                                    <div style={{
                                        backgroundColor: '#FFFBEB',
                                        borderRadius: '50%',
                                        width: '24px',
                                        height: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="#F59E0B"
                                        >
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                                        </svg>
                                    </div>
                                </OverlayTrigger>
                            )}
                            {isVencido && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={(props) => renderTooltip(props, "Vencido")}
                                >
                                    <div style={{
                                        backgroundColor: '#FEF2F2',
                                        borderRadius: '50%',
                                        width: '24px',
                                        height: '24px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="#EF4444"
                                        >
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                                        </svg>
                                    </div>
                                </OverlayTrigger>
                            )}
                        </div>
                    </div>
                );
            },
        },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ];

    const pages = [
        {
            titulo: "Dados",
            campos: ["idFilial", "valor", "tipo", "status", "dataRealizado", "dataPagamentoFoiFeito", "_toggleAvancadoLancamento", "_labelBancoInfoLancamento", "idBanco"]
        },
        {
            titulo: "Detalhamento",
            campos: ["descricao", "categorias"]
        },
        {
            titulo: "Vínculos",
            campos: ["idLocacao", "idVeiculo", "idUsuario", "alertaSobrePrazoMinimo", "naoDeveRefletirNoAsaas"]
        },
        {
            titulo: "Juros e Multa",
            campos: ["_avisoJurosSomenteAsaas", "_avisoJurosAcatados", "_labelJuros", "jurosAoMes", "_valorJurosAoMes",
                "_avisoLimiteJuros", "_labelMulta", "_multaEscolha", "multaPercentual", "_valorMulta", "multaFixa", "_avisoLimiteMulta"]
        },
        {
            titulo: "Adicionais",
            campos: ["desejoRepetirLancamento", "dataInicio", "periodicidadePagamento", "parcelasPagamento", "AlterarLancamentosPosteriorAData", "arquivo", "imagem"]
        }
    ];

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6, onCampoDigitar: (idFilial: string) => setFilialNoForm(idFilial || null) });

    // Filtra veículos e locações pelo filial selecionado no formulário
    const veiculosFiltrados = filialNoForm
        ? veiculosLista.filter((v: any) => !v.idFilial || v.idFilial === filialNoForm).map((v: any) => ({
            codigo: v.id, valor: v.id,
            label: labelComFilial(`${v.placa} - ${v.marca} - ${v.modelo} - ${v.ano}`, v.idFilial),
        }))
        : veiculos;

    const locacoesFiltradas = filialNoForm
        ? locacoes.filter((l: any) => !l.idFilial || l.idFilial === filialNoForm).map((l: any) => ({
            codigo: l.id, valor: l.id,
            label: labelComFilial(`${l.veiculo.placa} - ${l.locatario.nome}`, l.idFilial),
        }))
        : locacoesOp;

    // Juros/multa só existem na cobrança do Asaas: entrada pendente, de locação, com cobrança ligada.
    // Lê os valores do formulário (na edição o estado de tipo/status da tela pode não ter sido tocado).
    // Locação marcada para não enviar ao Asaas não gera cobrança de lançamento (o backend recusa).
    // NULL conta como "envia", igual ao DeveIntegrarAoAsaas do servidor.
    const locacaoEnviaAoAsaas = (idLocacao?: string) => {
        const locacao: any = locacoes.find((l: any) => l.id == idLocacao);
        return !!locacao && locacao.integrarAoAsaas !== false;
    };
    const mostrarJurosMulta = (v: any) => {
        const tipo = v?.tipo ?? tipoLancamento;
        const status = v?.status ?? statusEscolhido;
        return integradoAsaas && !!v?.idLocacao && locacaoEnviaAoAsaas(v.idLocacao) && tipo == TipoLancamento.Entrada
            && status == TipoStatusLancamento.Pendente && !v?.naoDeveRefletirNoAsaas;
    };

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Informações do Lançamento', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 1, visible: true, },
        { label: 'Valor', nome: 'valor', required: true, tipo: 'money', largura: 4, coluna: 1, linha: 1, visible: true, },
        {
            label: 'Tipo do lançamento?', nome: 'tipo', required: true, tipo: 'select', largura: 4, coluna: 2, linha: 1, visible: true, opcoes: [
                { label: converterTipoLancamentoParaTexto(TipoLancamento.Entrada), valor: TipoLancamento.Entrada },
                { label: converterTipoLancamentoParaTexto(TipoLancamento.Saida), valor: TipoLancamento.Saida },
            ], onCampoDigitar(e) {
                setTipoLancamento(e);
            },
        },
        {
            label: 'Informe a(s) Categoria(s)', nome: 'categorias', required: false, tipo: 'multiselect', largura: 12, coluna: 1, linha: 1, visible: true, selectMultiProps:
            {
                dataSource: categorias,
                onSelectionChange: ((data: any) => {
                    setCategoriasEscolhidas(data);
                    setMexeuNasCategorias(true);
                }),
                modo: modo,
                initialSelected: categoriasSelecionadas,
                criticarRepeticao: true,
                maxRecords: 2,
                optionBackgroundField: "cor",
                optionLabelField: "nome;descricao"
            }
        },
        { label: 'Observação', nome: 'descricao', required: false, tipo: 'memo', largura: 12, coluna: 1, linha: 1, visible: true, tudoMaiusculo: true, },
        {
            label: 'Status', nome: 'status', required: true, tipo: 'select', largura: 4, coluna: 1, linha: 2, visible: true, opcoes: [
                { label: converterTipoStatusLancamentoParaTexto(TipoStatusLancamento.Resolvido), valor: TipoStatusLancamento.Resolvido },
                { label: converterTipoStatusLancamentoParaTexto(TipoStatusLancamento.Pendente), valor: TipoStatusLancamento.Pendente },
            ], onCampoDigitar(e) {
                setStatusEscolhido(e);
            },
        },
        { label: 'Data de Vencimento', nome: 'dataRealizado', required: true, tipo: 'datetime-local', largura: 4, coluna: 2, linha: 2, visible: true, onCampoDigitar(e) {
            setDataDeVencimento(e);
        }, },
        {
            label: 'Data do Pagamento', nome: 'dataPagamentoFoiFeito', required: false, tipo: 'datetime-local', largura: 4, coluna: 3, linha: 2, visible: (e: any) => {
                return (e.status as TipoStatusLancamento) == TipoStatusLancamento.Resolvido
            },
        },
        { label: 'Informações de Vínculos', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 5, visible: true, },

        {
            label: 'Locação', nome: 'idLocacao', required: false, tipo: 'select', largura: 6, coluna: 1, linha: 6, visible: true, opcoes: locacoesFiltradas, carregando: carregandoSelect, selectBoxIsCleareable: true,
            onCampoDigitar(e) {
                if (e) {
                    const locacao = locacoes.find(l => l.id == e);
                    if (locacao) {
                        setLocacaoSelecionada(true);
                        setLancamentoAtualizacao({ idVeiculo: locacao.idVeiculo });
                        setLancamentoForcarAtualizacao(true);
                    }
                } else {
                    setLocacaoSelecionada(false)
                }
            },
        },
        // Etapa "Juros e Multa", no mesmo desenho da locação. Vão para a cobrança e quem calcula é o
        // Asaas: só fazem sentido quando este lançamento vira cobrança (entrada pendente de locação).
        {
            label: '', nome: '_avisoJurosSomenteAsaas', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 1,
            visible: (v: any) => !mostrarJurosMulta(v) && !(Number(v?.valorOriginal) > 0),
            alertType: 'info', alertIcon: FaInfo, alertTitle: 'Juros e multa são cobrados pelo Asaas',
            alertMessage: 'Só valem para lançamentos de entrada, a vencer, ligados a uma locação que envia cobranças ao Asaas (opção "Enviar esta locação para o Asaas" ligada na locação).',
        },
        // Limites do Asaas avisados na própria etapa, e não só no salvar.
        {
            label: '', nome: '_avisoLimiteJuros', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 4,
            visible: (v: any) => mostrarJurosMulta(v) && numeroDoForm(v?.jurosAoMes) > 10,
            alertType: 'danger', alertTitle: 'Juros acima do permitido',
            alertMessage: 'O Asaas aceita no máximo 10% de juros ao mês. Ajuste antes de salvar.',
        },
        {
            label: '', nome: '_avisoLimiteMulta', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 8,
            visible: (v: any) => mostrarJurosMulta(v) && (
                ((v?._multaEscolha ?? 'percentual') === 'percentual' && numeroDoForm(v?.multaPercentual) > 100)
                || (v?._multaEscolha === 'fixa' && numeroDoForm(v?.multaFixa) > numeroDoForm(v?.valor))),
            alertType: 'danger', alertTitle: 'Multa acima do permitido',
            alertMessage: 'A multa percentual não pode passar de 100%, e a multa fixa não pode ser maior que o valor do lançamento.',
        },
        {
            label: '', nome: '_avisoJurosAcatados', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 1,
            visible: (v: any) => Number(v?.valorOriginal) > 0,
            alertType: 'info', alertIcon: FaInfo, alertTitle: 'Pago com juros/multa',
            alertMessage: `O Asaas cobrou juros/multa por atraso. Valor original ${formatarParaReais(Number(lancamentoSelecionado?.valorOriginal) || 0)}, valor recebido ${formatarParaReais(Number(lancamentoSelecionado?.valor) || 0)}.`,
        },
        {
            coluna: 1, label: 'Juros', largura: 12, nome: '_labelJuros', tipo: 'label', linha: 2, required: false, apenasLeitura: true,
            visible: (v: any) => mostrarJurosMulta(v),
            subLabel: 'Aplicados pelo Asaas quando o pagamento atrasar. O Asaas calcula e cobra; o valor pago é registrado aqui.',
        },
        {
            coluna: 1, label: 'Juros ao mês', largura: 4, nome: 'jurosAoMes', tipo: 'percentual', linha: 3, required: false,
            visible: (v: any) => mostrarJurosMulta(v),
            ajudinha: { texto: 'Percentual ao mês cobrado pelo Asaas sobre o valor do lançamento, proporcional aos dias de atraso. Máximo de 10%.' },
        },
        {
            coluna: 2, label: 'Valor de juros ao mês', largura: 4, nome: '_valorJurosAoMes', tipo: 'custom', linha: 3, required: false,
            visible: (v: any) => mostrarJurosMulta(v), component: ValorJurosAoMesCalculado,
        },
        {
            coluna: 1, label: 'Multa', largura: 12, nome: '_labelMulta', tipo: 'label', linha: 5, required: false, apenasLeitura: true,
            visible: (v: any) => mostrarJurosMulta(v),
            subLabel: 'A multa será somada ao valor caso o pagamento seja feito após a data do vencimento.',
        },
        {
            label: '', nome: '_multaEscolha', required: false, tipo: 'toggle', largura: 12, coluna: 1, linha: 6, defaultValueToggle: 'percentual',
            visible: (v: any) => mostrarJurosMulta(v) && modo !== TipoFormulario.tpVisualizacao,
            opcoes: [{ label: 'Percentual', valor: 'percentual' }, { label: 'Valor Fixo', valor: 'fixa' }],
        },
        {
            coluna: 1, label: 'Valor percentual da multa', largura: 4, nome: 'multaPercentual', tipo: 'percentual', linha: 7, required: false,
            visible: (v: any) => mostrarJurosMulta(v) && (v?._multaEscolha ?? 'percentual') === 'percentual',
            ajudinha: { texto: 'Percentual de multa sobre o valor do lançamento quando o pagamento atrasar.' },
        },
        {
            coluna: 2, label: 'Valor da multa', largura: 4, nome: '_valorMulta', tipo: 'custom', linha: 7, required: false,
            visible: (v: any) => mostrarJurosMulta(v) && (v?._multaEscolha ?? 'percentual') === 'percentual', component: ValorMultaCalculado,
        },
        {
            coluna: 1, label: 'Valor da multa', largura: 4, nome: 'multaFixa', tipo: 'money', linha: 7, required: false,
            visible: (v: any) => mostrarJurosMulta(v) && v?._multaEscolha === 'fixa',
        },
        { label: 'Marque para não gerar cobrança no Asaas para esse locatário', nome: 'naoDeveRefletirNoAsaas', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 7, visible: (v: any) => integradoAsaas && locacaoSelecionada && locacaoEnviaAoAsaas(v?.idLocacao) && tipoLancamento == TipoLancamento.Entrada && statusEscolhido == TipoStatusLancamento.Pendente, },
        {
            linha: 8, coluna: 1, largura: 6,
            nome: 'idUsuario', label: 'Vendedor',
            tipo: 'select' as const, required: false,
            visible: (v: any) => !v?.idLocacao,
            apenasLeitura: !isAdmin,
            selectBoxIsCleareable: true,
            opcoes: usuariosEmpresa.map(u => ({ label: u.nome, valor: u.id }))
        },
        {
            label: 'Veículo', nome: 'idVeiculo', required: false, tipo: 'select', largura: 6, coluna: 2, linha: 6, visible: true, opcoes: veiculosFiltrados, carregando: carregandoSelect, apenasLeitura: locacaoSelecionada || modo == TipoFormulario.tpVisualizacao, selectBoxIsCleareable: true
        },
        {
            label: '', alertMessage:
                'O vínculo com uma locação ou veículo não é obrigatório para a criação de um lançamento. É possível registrar um lançamento avulso, sem qualquer associação, ou vinculá-lo a uma locação ou veículo, se necessário',
            nome: 'alertaSobrePrazoMinimo', required: false, tipo: 'aviso', largura: 12, coluna: 1, linha: 1, visible: true,
            alertType: 'info', alertIcon: FaInfo, alertDismissible: true, alertTitle: "Sobre vínculos de lançamentos:"
        },
        { label: 'Informações Adicionais', nome: '', required: true, tipo: 'label', largura: 12, coluna: 1, linha: 7, visible: modo == TipoFormulario.tpCadastro, },
        {
            label: 'Marque se deseja repetir este lançamento em parcelas', nome: 'desejoRepetirLancamento', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 9, visible: modo == TipoFormulario.tpCadastro, onCampoDigitar(e) {
                setHabilitarCamposRepeicao(e);
                setLancamentoAtualizacao({ dataInicio: dataDeVencimento });
                setLancamentoForcarAtualizacao(true);
            },
        },
        {
            label: 'Data da primeira parcela', nome: 'dataInicio', required: habilitarCamposRepeticao, tipo: 'datetime-local', largura: 4, coluna: 1, linha: 10, visible: modo == TipoFormulario.tpCadastro && habilitarCamposRepeticao, apenasLeitura: !habilitarCamposRepeticao
        },
        {
            label: 'Recorrência da parcela', nome: 'periodicidadePagamento', required: habilitarCamposRepeticao, tipo: 'select', largura: 4, coluna: 2, linha: 10, visible: modo == TipoFormulario.tpCadastro && habilitarCamposRepeticao, opcoes: OpcoesPeriodicidadePagamento, apenasLeitura: !habilitarCamposRepeticao
        },
        {
            label: 'Quantidade de parcelas', nome: 'parcelasPagamento', required: habilitarCamposRepeticao, tipo: 'number', largura: 4, coluna: 3, linha: 10, visible: modo == TipoFormulario.tpCadastro && habilitarCamposRepeticao, apenasLeitura: !habilitarCamposRepeticao
        },
        {
            label: 'Alterar lançamentos posteriores à data do lançamento atual', nome: 'AlterarLancamentosPosteriorAData', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 11, visible: (modo == TipoFormulario.tpEdicao) && (lancamentoSelecionado.ehLancamentoOriginal != true),
            ajudinha: { texto: "Ao marcar esta opção, todos os lançamentos com data prevista posterior à deste lançamento terão seus valores atualizados." }
        },
        {
            label: 'Arquivo', nome: 'arquivo', required: false, tipo: 'file', largura: 6, coluna: 1, linha: 12, visible: true,
        },
        {
            label: 'Imagem', nome: 'imagem', required: false, tipo: 'image', largura: 6, coluna: 2, linha: 12, visible: true,
        },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 12, visible: false, },
        {
            label: '', nome: '_toggleAvancadoLancamento', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 90,
            component: () => (
                <button
                    type="button"
                    onClick={() => setMostrarAvancadoLancamento(!mostrarAvancadoLancamento)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoLancamento ? 'Ocultar opções avançadas' : 'Mostrar opções avançadas'}
                </button>
            ),
        },
        {
            label: 'Atenção', nome: '_labelBancoInfoLancamento', tipo: 'label', required: false,
            largura: 12, coluna: 1, linha: 91, visible: () => mostrarAvancadoLancamento,
            subLabel: 'Esta seleção NÃO irá transferir valores de forma automática para a conta. Será apenas para facilitar a conciliação financeira.',
        },
        {
            label: 'Banco', nome: 'idBanco', tipo: 'select', required: false,
            largura: 12, coluna: 1, linha: 92, visible: () => mostrarAvancadoLancamento,
            selectBoxIsCleareable: true,
            opcoes: bancosLancamentoOpcoes,
        },
    ];

    const tratarErro = (error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSubmiting(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação Lançamento: ${errorMessage}`);
    }

    const handleFecharModal = () => {
        setHabilitarCamposRepeicao(false);
        setExibirFormModal(false);
        if (modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) {
            setBuscar(false);
            setBuscar(true);
        }
    }

    const handleCadastrar = () => {
        if (usuarioTemPermissao(token, 'lancamento_novo')) {
            setDataDeVencimento(undefined);
            setModo(TipoFormulario.tpCadastro)
            setLancamentoSelecionado({} as Lancamento);
            setLancamentoAtualizacao({ status: TipoStatusLancamento.Resolvido, idUsuario: obterIdUsuario(token) });
            setLancamentoForcarAtualizacao(true);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo Lancamento');
        }
    }

    // O seletor de multa (percentual / valor fixo) é só de tela: nasce do que está gravado.
    const comTipoMulta = (lancamento: any) => ({
        ...lancamento,
        _multaEscolha: Number(lancamento?.multaFixa) > 0 && !(Number(lancamento?.multaPercentual) > 0) ? 'fixa' : 'percentual',
    });

    const handleEditar = (lancamento: any) => {
        if (usuarioTemPermissao(token, 'lancamento_editar')) {

            if(lancamento.asaasPaymentId && lancamento.status == TipoStatusLancamento.Resolvido) {
                toast.error('Não é possível editar um lançamento que está resolvido e vinculado ao Asaas.');
                return;
            }

            setModo(TipoFormulario.tpEdicao)
            setLancamentoSelecionado(comTipoMulta(lancamento));
            setLocacaoSelecionada(!!lancamento.idLocacao);
            if (lancamento.idBanco) {
                setMostrarAvancadoLancamento(true);
            } else {
                setMostrarAvancadoLancamento(false);
            }
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar um Lancamento');
        }
    }

    const handleExcluirLancamento = async (lancamento: Lancamento, excluirParcelasFuturasSeTiver?: boolean) => {
        setCarregando(true);
        await api.delete(`/lancamento/${lancamento.id}/${excluirParcelasFuturasSeTiver}`)
            .then(response => {
                setTimeout(() => {
                    toast.success('Lançamento foi excluído com sucesso');
                    setBuscar(false);
                    setBuscar(true);
                    setCarregando(false);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
                setCarregando(false);
            });
    }

    const handleExclusao = async (lancamento: Lancamento) => {
        if (usuarioTemPermissao(token, 'lancamento_excluir')) {
            if (lancamento.idManutencao) {
                toast.info('Este lançamento foi gerado por uma manutenção do veículo. Para alterar ou excluir, use o cadastro de manutenção do veículo.');
                return;
            }
            if (lancamento.idLancamentoOriginal) {
                const confirmed = await confirm('Este lançamento está vinculado a parcelas posteriores. Deseja removê-las juntamente com este lançamento?');
                if (confirmed) {
                    handleExcluirLancamento(lancamento, true);
                } else {
                    handleExcluirLancamento(lancamento, false);
                }
            } else {
                handleExcluirLancamento(lancamento, false);
            }
        }
    };

    useEffect(() => {
        const fetchLocacoes = async () => {
            setCarregandoSelect(true);
            try {
                const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
                const novasOpcoes = response.data.map((locacao: any) => ({
                    codigo: locacao.id,
                    valor: locacao.id,
                    label: labelComFilial(`${locacao.veiculo.placa} - ${locacao.locatario.nome}`, locacao.idFilial),
                }));
                const opcoesFiltro = response.data.map((locacao: any) => ({
                    value: locacao.id,
                    label: labelComFilial(`${locacao.veiculo.placa} - ${locacao.locatario.nome}`, locacao.idFilial),
                }));
                setLocacoesOp(novasOpcoes);
                setLocacoesFiltroOp(opcoesFiltro);
                setLocacoes(response.data)

                // Opcoes de locatario derivadas das locacoes (unicos).
                const mapaLocatarios = new Map<string, string>();
                response.data.forEach((locacao: any) => {
                    const idLoc = locacao.idLocatario || locacao.locatario?.id;
                    if (idLoc && !mapaLocatarios.has(idLoc)) {
                        mapaLocatarios.set(idLoc, labelComFilial(`${locacao.locatario?.nome ?? ''}${locacao.locatario?.documento ? ` (${locacao.locatario.documento})` : ''}`.trim(), locacao.idFilial));
                    }
                });
                setLocatariosFiltroOp(Array.from(mapaLocatarios.entries()).map(([value, label]) => ({ value, label })));
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoSelect(false);
            }
        }
        const fetchVeiculos = async () => {
            setCarregandoSelect(true);
            try {
                const response = await api.get(`/VeiculoPorEmpresaAtivos/${obterIdTenent(token)}`);
                const novasOpcoes = response.data.map((veiculo: any) => ({
                    codigo: veiculo.id,
                    valor: veiculo.id,
                    label: labelComFilial(`${veiculo.placa} - ${veiculo.marca} - ${veiculo.modelo} - ${veiculo.ano}`, veiculo.idFilial),
                }));
                const opcoesFiltro = response.data.map((veiculo: any) => ({
                    value: veiculo.id,
                    label: labelComFilial(`${veiculo.placa} - ${veiculo.marca} - ${veiculo.modelo}`, veiculo.idFilial),
                }));
                setVeiculos(novasOpcoes);
                setVeiculosFiltroOp(opcoesFiltro);
                setVeiculosLista(response.data);
            } catch (error) {
                tratarErro(error as AxiosError<ApiError>);
            } finally {
                setCarregandoSelect(false);
            }
        }
        const fetchCategoriaPorEmpresa = async () => {
            setCarregandoSelect(true);
            await api.get(`/CategoriaPorEmpresa/${obterIdTenent(token)}`)
                .then(response => {
                    const opcoesFiltro = response.data.map((cat: any) => ({
                        value: cat.id,
                        label: cat.nome
                    }));
                    setCategoriasFiltroOp(opcoesFiltro);
                    setTimeout(() => {
                        setCategorias(response.data);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error);
                });
        }

        fetchLocacoes();
        fetchVeiculos();
        fetchCategoriaPorEmpresa();
    }, [exibirFormModal])

    useEffect(() => {
        if (lancamentoForcarAtualizacao) {
            setLancamentoForcarAtualizacao(false);
        }
    }, [lancamentoForcarAtualizacao]);

    const handleVisualizacao = async (lancamento: any) => {
        if (usuarioTemPermissao(token, 'lancamento_visualizar')) {
            setLancamentoSelecionado(comTipoMulta(lancamento));
            setExibirFormModal(true);
            setModo(TipoFormulario.tpVisualizacao);
            setHabilitarCamposRepeicao(false);
            if (modo == TipoFormulario.tpCadastro) {
                setCategoriasEscolhidas([]);
                setCategoriasSelecionadas([]);
                setLancamentoForcarAtualizacao(true);
            }
        }
    };

    const atualizarStatusLancamento = async (idLancamento: string, status: TipoStatusLancamento, filtrosAtuais: any) => {
        await api.put(`/AtualizarStatusLancamento/${idLancamento}/${status}`, null, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Atualiza a grid re-buscando
        handleBuscarLancamentos(
            filtrosAtuais.dataInicio,
            filtrosAtuais.dataFim,
            filtrosAtuais.status,
            filtrosAtuais.tipo
        );

        if (status == TipoStatusLancamento.Resolvido) {
            toast.success("Lançamento confirmado com sucesso");
        } else {
            toast.success("Lançamento marcado como pendente com sucesso");
        }
    }

    const requisicaoBemSucedida = (response?: any) => {
        setExibirFormModal(false);
        toast.success('Lançamento salvo com sucesso');
    }

    const onSave = async (entidade: any) => {
        if (isSubmiting) return;

        if (!usuarioTemPermissao(token, 'lancamento_novo') && !usuarioTemPermissao(token, 'lancamento_editar')) {
            return;
        }

        // Ao editar o lançamento ORIGINAL de um parcelamento, perguntar (modal) se as alterações
        // devem ser propagadas para as parcelas posteriores ou aplicadas só ao original.
        // OBS: ParcelasPagamento não é persistido no lançamento, então identificamos o original
        // por ehLancamentoOriginal (que é persistido) e contamos as filhas pela lista carregada.
        const idOriginal = lancamentoSelecionado?.id ?? entidade.id;
        const ehOriginal = modo === TipoFormulario.tpEdicao
            && (lancamentoSelecionado?.ehLancamentoOriginal === true || entidade.ehLancamentoOriginal === true);

        if (ehOriginal) {
            const posteriores = (lancamentos || []).filter((l: any) => l.idLancamentoOriginal === idOriginal).length;
            const alvo = posteriores === 1
                ? 'ao lançamento posterior'
                : posteriores > 1
                    ? `aos ${posteriores} lançamentos posteriores`
                    : 'às demais parcelas posteriores';
            const propagar = await confirm(
                `Este é o lançamento original de um parcelamento.\n` +
                `Deseja aplicar as alterações também ${alvo}?\n\n` +
                `Confirmar: aplica a todas.\nCancelar: aplica somente a este lançamento.`
            );
            await enviarLancamento(entidade, propagar);
            return;
        }

        await enviarLancamento(entidade, false);
    };

    const enviarLancamento = async (entidade: any, propagarParaParcelas: boolean) => {
        if (isSubmiting) return;

        setIsSubmiting(true);

        try {
            const dadosASalvar = new FormData();

            let id = entidade.id || crypto.randomUUID();

            const lancamentoASalvar = {
                id,
                dataCriacao: new Date().toISOString(),
                dataRealizado: entidade.dataRealizado,
                dataPagamentoFoiFeito: (entidade.status as TipoStatusLancamento) == TipoStatusLancamento.Pendente ? null : entidade.dataPagamentoFoiFeito,
                descricao: entidade.descricao || '-',
                idEmpresa: obterIdTenent(token),
                tipo: entidade.tipo,
                valor: parseFloat(entidade.valor) || 0,
                idLocacao: entidade.idLocacao || null,
                idVeiculo: entidade.idVeiculo || null,
                status: entidade.status || TipoStatusLancamento.Pendente,
                dataInicio: entidade.dataInicio || null,
                periodicidadePagamento: entidade.periodicidadePagamento || TipoPeriodicidadePagamento.Nenhum,
                parcelasPagamento: entidade.parcelasPagamento || 0,
                ehLancamentoOriginal: entidade.ehLancamentoOriginal || false,
                idLancamentoOriginal: entidade.idLancamentoOriginal || null,
                alterarLancamentosPosteriorAData: entidade.AlterarLancamentosPosteriorAData || false,
                propagarParaParcelas: propagarParaParcelas,
                idBanco: entidade.idBanco || null,
                idFilial: entidade.idFilial || null,
                idUsuario: entidade.idUsuario || null,
            };

            for (const key in lancamentoASalvar) {
                const value = (lancamentoASalvar as any)[key];
                if (value !== null && value !== undefined) {
                    dadosASalvar.append(key, value);
                }
            }
            // Explicit clearing: if idBanco is not set, send empty string to signal "no bank"
            if (!lancamentoASalvar.idBanco) {
                dadosASalvar.append('idBanco', '');
            }

            const categorias = mexeuNasCategorias ? categoriasEscolhidas :
                (modo === TipoFormulario.tpEdicao ? categoriasEscolhidas : []);

            if (categorias && categorias.length > 0) {
                categorias.forEach((categoria: any, index: number) => {
                    const idCategoria = categoria.id;
                    const idLancamentoCategoria = modo === TipoFormulario.tpEdicao &&
                        lancamentoSelecionado?.lancamentoCategorias?.find((lc: any) => lc.idCategoria === idCategoria)?.id
                        || crypto.randomUUID();

                    dadosASalvar.append(`lancamentoCategorias[${index}].id`, idLancamentoCategoria);
                    dadosASalvar.append(`lancamentoCategorias[${index}].idCategoria`, idCategoria);
                    dadosASalvar.append(`lancamentoCategorias[${index}].idLancamento`, id);
                });
            }

            if (entidade.imagem) dadosASalvar.append("imagem", entidade.imagem);
            if (entidade.arquivo) dadosASalvar.append("arquivo", entidade.arquivo);

            const imagemRemoved = imagemRemovida && !entidade.imagem;
            dadosASalvar.append("removerImagem", String(imagemRemoved));

            const arquivoRemoved = arquivoRemovido && !entidade.arquivo;
            dadosASalvar.append("removerArquivo", String(arquivoRemoved));

            if (entidade.asaasPaymentId) {
                dadosASalvar.append("asaasPaymentId", entidade.asaasPaymentId);
            }

            dadosASalvar.append("deveRefletirNoAsaas", String(locacaoSelecionada ? !entidade.naoDeveRefletirNoAsaas : false));

            // Juros/multa: com a etapa visível, vão sempre com o marcador, para que apagar na tela também
            // apague no servidor. Com a etapa escondida o marcador NÃO vai e o servidor preserva o que
            // está gravado: a etapa também some por falta de dados (ex.: usuário sem acesso às locações,
            // lista ainda carregando), e mandar vazio apagaria juros/multa da cobrança viva.
            if (mostrarJurosMulta(entidade)) {
                const juros = Number(entidade.jurosAoMes) || 0;
                const multaEscolha = entidade._multaEscolha ?? 'percentual';
                const multaPct = multaEscolha === 'percentual' ? Number(entidade.multaPercentual) || 0 : 0;
                const multaFixa = multaEscolha === 'fixa' ? Number(entidade.multaFixa) || 0 : 0;
                dadosASalvar.append("jurosMultaInformados", "true");
                if (juros > 0) dadosASalvar.append("jurosAoMes", String(juros));
                if (multaPct > 0) dadosASalvar.append("multaPercentual", String(multaPct));
                if (multaFixa > 0) dadosASalvar.append("multaFixa", String(multaFixa));
            }

            await (modo === TipoFormulario.tpCadastro ? api.post : api.put)(
                '/lancamento/',
                dadosASalvar,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );

            setTimeout(() => {
                requisicaoBemSucedida();
                // Atualiza a lista automaticamente após salvar, re-executando a busca com os
                // filtros atualmente aplicados (preserva o filtro da tela). Não depende do toggle
                // de `buscar`, que pode não disparar o refetch dependendo do timing dos efeitos.
                handleBuscarLancamentos(filtros.dataInicio, filtros.dataFim, filtros.status, filtros.tipo);
                setIsSubmiting(false);
            }, 250);

        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
            setIsSubmiting(false);
        }
    };

    useEffect(() => {
        if (forcarAtualizacaoGrid == true) {
            setForcarAtualizacaoGrid(false);
        }
    }, [forcarAtualizacaoGrid]);

    const getId = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get("id");
    };

    const getIdManutencao = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get("manutencao");
    };

    const getIdEstoque = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get("estoque");
    };

    const getIdMulta = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get("multa");
    };

    useEffect(() => {
        const idEstoque = getIdEstoque();
        if (idEstoque) {
            setFiltrosAvancados(prev => ({ ...prev, idLocacao: idEstoque }));
        }
    }, []);

    const handleBuscarLancamentos = async (
        dataIni: Date | null,
        dataFim: Date | null,
        status: TipoStatusLancamento,
        tipo: TipoLancamento,
        tipoPeriodo?: "vencimento" | "pagamento"
    ) => {
        if ((dataIni && !dataFim) || (dataFim && !dataIni)) {
            toast.info('Informe a Data inicial e a Data Final');
            setCarregando(false);
            return;
        } else if ((dataIni && dataFim) && diaInicialDepoisDoFinal(dataIni, dataFim)) {
            toast.info('A Data Final deve ser Maior ou Igual a data Inicial');
            setCarregando(false);
            return;
        } else {
            setFiltros({
                dataInicio: dataIni,
                dataFim: dataFim,
                status: status,
                tipo: tipo
            });

            try {
                setCarregando(true);

                let response;
                const idManutencao = getIdManutencao();
                const id = getId();

                const idEstoque = getIdEstoque();
                const idMulta = getIdMulta();

                if (idMulta) {
                    response = await api.get(`/Lancamento/PorMulta/${idMulta}`);
                } else if (idManutencao) {
                    response = await api.get(`/Lancamento/PorManutencao/${idManutencao}`);
                } else if (idEstoque) {
                    response = await api.get(`/Lancamento/PorEstoque/${idEstoque}`);
                } else if (id) {
                    response = await api.get(`/Lancamento/${id}`);
                } else {
                    const contexto: ContextoLancamento = {
                        idEmpresa: obterIdTenent(token),
                        dataInicial: dataIni || undefined,
                        dataFinal: dataFim || undefined,
                        status: status,
                        tipo: tipo,
                        trazerArquivos: true,
                        tipoPeriodo: tipoPeriodo || undefined,
                    };

                    response = await api.get('/ObterTodosPorContexto', {
                        params: contexto,
                    });
                }

                const dados = Array.isArray(response.data) ? response.data : [response.data];

                setLancamentos(dados);
                setCarregando(false);
            } catch (error: any) {
                tratarErro(error as AxiosError<ApiError>);
                setCarregando(false);
            }
        }
    };

    const handleObterFatura = async (e: any) => {
        if (!e.asaasPaymentId) {
            toast.error("Não é possível obter Link da Fatura. Esse pagamento não existe no Asaas.");
            return;
        }
    
        try {
            // Usa o endpoint que resolve a conta Asaas pela filial do registro (FaturaAsaas/{id}),
            // garantindo o link correto quando a filial tem conta Asaas própria.
            const response = await api.get(`/Pagamento/FaturaAsaas/${e.id}`);
            const resultado = response.data;
            setCarregando(false);

            if (resultado) {
                await navigator.clipboard.writeText(resultado);
                toast.success('Link da Fatura copiado para a área de transferência!', { autoClose: 10000 });
            }
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const configFiltros: ConfiguracaoFiltros = {
        dropdowns: [
            {
                key: 'locacao',
                label: 'Locação',
                placeholder: 'Selecione a locação...',
                opcoes: locacoesFiltroOp,
                value: filtrosAvancados.idLocacao,
                onChange: (v) => setFiltrosAvancados({...filtrosAvancados, idLocacao: v})
            },
            {
                key: 'locatario',
                label: 'Locatário',
                placeholder: 'Selecione o locatário...',
                opcoes: locatariosFiltroOp,
                value: filtrosAvancados.idLocatario,
                onChange: (v) => setFiltrosAvancados({...filtrosAvancados, idLocatario: v})
            },
            {
                key: 'veiculo',
                label: 'Veículo',
                placeholder: 'Selecione o veículo...',
                opcoes: veiculosFiltroOp,
                value: filtrosAvancados.idVeiculo,
                onChange: (v) => setFiltrosAvancados({...filtrosAvancados, idVeiculo: v})
            },
            {
                key: 'categoria',
                label: 'Categoria',
                placeholder: 'Selecione as categorias...',
                opcoes: categoriasFiltroOp,
                value: filtrosAvancados.idsCategorias,
                multiSelect: true,
                onChange: (v) => setFiltrosAvancados({...filtrosAvancados, idsCategorias: v})
            }
        ]
    };

    // Ações em lote agem sobre os lançamentos exibidos na tabela (a listagem repassa os ids das linhas
    // com período, tipo de data, status, tipo, filial, filtros avançados e busca já aplicados).
    const prepararDadosLote = async (tipo: AcaoLoteLancamento, linhasExibidas: (string | number)[]) => {
        const ids = idsDasLinhasExibidas(linhasExibidas);
        if (ids.length === 0) {
            toast.info(MENSAGEM_SEM_LANCAMENTOS_NA_TABELA);
            return;
        }

        setCarregando(true);
        try {
            const response = await api.post(`/Lancamento/PreviewProcessamentoEmLotePorIds/${obterIdTenent(token)}?acao=${tipo}`, ids);
            const dados = response.data;

            setCarregando(false);

            if (!dados || dados.length === 0) {
                toast.info(mensagemSemLancamentosParaAcao(tipo, ids.length));
                return;
            }

            setIdsLote(ids);
            setDadosLote(dados);
            setAcaoLote(tipo);
            setShowModalLote(true);
        } catch (error: any) {
            setCarregando(false);
            tratarErro(error);
        }
    };

    const handleConfirmarLote = async () => {
        setShowModalLote(false);
        setCarregando(true);

        try {
            const url = (endpoint: string) => `/Lancamento/${endpoint}/${obterIdTenent(token)}`;

            if (acaoLote === 'baixar') {
                const response = await api.put(url('BaixarPorIds'), idsLote);
                processarResposta(response.data);
                return;
            }

            if (acaoLote === 'cancelar') {
                const response = await api.put(url('CancelarPorIds'), idsLote);
                processarResposta(response.data);
                return;
            }

            if (acaoLote === 'excluir') {
                const response = await api.delete(url('ExcluirEmLotePorIds'), { data: idsLote });
                processarResposta(response.data);
                return;
            }
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };
    
    const processarResposta = (quantidade: number) => {
        if (quantidade > 0) {
            toast.success(`${quantidade} lançamentos foram processados com sucesso.`);
            handleBuscarLancamentos(
                filtros.dataInicio,
                filtros.dataFim,
                filtros.status,
                filtros.tipo
            );
        } else {
            toast.info('Nenhum lançamento foi processado.');
        }
    };    

    const handleAjustarValorLote = async (linhasExibidas: (string | number)[]) => {
        const ids = idsDasLinhasExibidas(linhasExibidas);
        if (ids.length === 0) {
            toast.info(MENSAGEM_SEM_LANCAMENTOS_NA_TABELA);
            return;
        }

        setCarregando(true);
        try {
            const response = await api.post(`/Lancamento/PreviewProcessamentoEmLotePorIds/${obterIdTenent(token)}`, ids);
            const dados = response.data;

            setCarregando(false);

            if (!dados || dados.length === 0) {
                toast.info(MENSAGEM_SEM_LANCAMENTOS_NA_TABELA);
                return;
            }

            setIdsLote(ids);
            setDadosLote(dados);
            setShowModalAjuste(true);
        } catch (error: any) {
            setCarregando(false);
            tratarErro(error);
        }
    };

    const handleConfirmarAjuste = async (tipoAjuste: string, valorAjuste: number) => {
        setShowModalAjuste(false);
        setCarregando(true);
        try {
            const params = new URLSearchParams();
            params.append('tipoAjuste', tipoAjuste);
            params.append('valorAjuste', valorAjuste.toString());

            const response = await api.put(`/Lancamento/AtualizarValorEmLotePorIds/${obterIdTenent(token)}?${params.toString()}`, idsLote);
            const quantidade = response.data;

            setCarregando(false);
            toast.success(`${quantidade} lançamentos tiveram seus valores atualizados.`);
            handleBuscarLancamentos(filtros.dataInicio, filtros.dataFim, filtros.status, filtros.tipo);

        } catch (error: any) {
            tratarErro(error);
        }
    };

    // A API exige lancamento_editar para resolver, cancelar, alterar valor e lançar no Asaas, e lancamento_excluir para excluir.
    const gerarFaturasEmLote = async (linhasExibidas: (string | number)[], unificar = false, comPix = false) => {
        const ids = idsDasLinhasExibidas(linhasExibidas);
        const { faturaveis, saidas } = lancamentosFaturaveis(lancamentosFiltrados, ids);
        if (faturaveis.length === 0) {
            toast.info(ids.length === 0 ? MENSAGEM_SEM_LANCAMENTOS_NA_TABELA : "A fatura só sai para lançamentos de entrada (receitas). Nenhum na tabela.");
            return;
        }
        if (faturaveis.length > LIMITE_DOCUMENTOS_EM_LOTE) {
            toast.info(`São ${faturaveis.length} lançamentos. Refine os filtros para gerar até ${LIMITE_DOCUMENTOS_EM_LOTE} faturas por vez.`);
            return;
        }
        setCarregando(true);
        try {
            const [locacoes, empresa, logo, pixes] = await Promise.all([
                carregarLocacoesPorId(idsDistintos(faturaveis.map(l => l.idLocacao))),
                carregarEmpresaDoToken(token),
                carregarLogoDaEmpresa(token),
                comPix ? carregarPixDosLancamentos(faturaveis) : Promise.resolve({} as Record<string, PixFatura>),
            ]);
            const nomeEmpresa = obterNomeEmpresa(token);
            const faturas = faturaveis.map(l => faturaDeLancamento(l, l.idLocacao ? locacoes[l.idLocacao] ?? null : null, empresa, nomeEmpresa, new Date(), l.id ? pixes[l.id] ?? null : null));
            let lista = unificar ? unificarPorCliente(faturas) : faturas;
            if (unificar && comPix) {
                lista = await Promise.all(lista.map(async f => comPixUnico(f, await carregarPixPorValor(valorEmAbertoDaFatura(f), f.idFilial))));
            }
            if (comPix && lista.every(f => !f.pixUnico && !f.parcelas.some(parcela => parcela.pix))) {
                toast.info("Nenhum lançamento em aberto com PIX disponível. Confira a chave PIX em Minha Conta.");
            }
            abrirPdfNoVisualizador(gerarPdfFaturas(lista, logo), `faturas_${Date.now()}`);
            if (saidas > 0) toast.info(`${saidas} lançamento(s) de saída ficaram fora da fatura.`);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const podeEditarLancamento = usuarioTemPermissao(token, 'lancamento_editar');
    const podeExcluirLancamento = usuarioTemPermissao(token, 'lancamento_excluir');
    const permissoesDasAcoes: Record<string, boolean> = {
        'Baixar Lançamentos (Resolver)': podeEditarLancamento,
        'Cancelar Lançamentos (Tornar Pendente)': podeEditarLancamento,
        'Alterar Valor em Lote': podeEditarLancamento,
        'Excluir em Lote': podeExcluirLancamento,
        'Resolver Lançamento': podeEditarLancamento,
        'Lançar no Asaas': podeEditarLancamento,
    };

    const acoesEmLote: AcaoEmLote[] = [
        {
            titulo: "Baixar Lançamentos (Resolver)",
            icone: FaCheck,
            onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => prepararDadosLote('baixar', linhasExibidas)
        },
        {
            titulo: "Cancelar Lançamentos (Tornar Pendente)",
            icone: FaTimesCircle,
            onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => prepararDadosLote('cancelar', linhasExibidas)
        },
        {
            titulo: "Alterar Valor em Lote",
            icone: FaEdit,
            onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => handleAjustarValorLote(linhasExibidas)
        },
        {
            titulo: "Excluir em Lote",
            icone: FaTrash,
            onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => prepararDadosLote('excluir', linhasExibidas)
        },
        {
            titulo: "Gerar Faturas",
            icone: FaFileInvoice,
            onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => gerarFaturasEmLote(linhasExibidas),
            subAcoes: [
                { titulo: "Individual", icone: FaFileAlt, onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => gerarFaturasEmLote(linhasExibidas) },
                { titulo: "Individual com QR Code PIX", icone: FaQrcode, onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => gerarFaturasEmLote(linhasExibidas, false, true) },
                { titulo: "Unificada", icone: FaLayerGroup, onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => gerarFaturasEmLote(linhasExibidas, true) },
                { titulo: "Unificada com QR Code PIX", icone: FaQrcode, onClick: (_dataInicio, _dataFim, _status, linhasExibidas) => gerarFaturasEmLote(linhasExibidas, true, true) },
            ]
        },
        // Lançamento acompanha a unidade do veículo/locação (via cascade); não é atribuível
        // diretamente em lote (F) — ação removida.
    ];

    const exportOptions = useMemo(() => [
        { field: 'descricao', headerName: 'Descrição' },
        { 
            field: 'valor', 
            headerName: 'Valor', 
            valueGetter: ({row}: {row: any}) => formatarParaReais(row.valor) 
        },
        { 
            field: 'tipo', 
            headerName: 'Tipo', 
            valueGetter: ({row}: {row: any}) => converterTipoLancamentoParaTexto(row.tipo) 
        },
        { 
            field: 'status', 
            headerName: 'Status', 
            valueGetter: ({row}: {row: any}) => converterTipoStatusLancamentoParaTexto(row.status) 
        },
        { 
            field: 'dataRealizado', 
            headerName: 'Data Vencimento', 
            valueGetter: ({row}: {row: any}) => row.dataRealizado ? new Date(row.dataRealizado).toLocaleDateString('pt-BR') : '' 
        },
        { 
            field: 'dataPagamentoFoiFeito', 
            headerName: 'Data Pagamento', 
            valueGetter: ({row}: {row: any}) => row.dataPagamentoFoiFeito ? new Date(row.dataPagamentoFoiFeito).toLocaleDateString('pt-BR') : '' 
        },
        { 
            field: 'locatario', 
            headerName: 'Locatário', 
            valueGetter: ({row}: {row: any}) => {
                const locacao = locacoes.find(l => l.id === row.idLocacao);
                return locacao?.locatario?.nome || '';
            }
        },
        { 
            field: 'veiculo', 
            headerName: 'Veículo', 
            valueGetter: ({row}: {row: any}) => {
                const v = veiculosLista.find(v => v.id === row.idVeiculo) || (row.idLocacao ? locacoes.find(l => l.id === row.idLocacao)?.veiculo : null);
                return v ? `${v.placa} - ${v.modelo}` : '';
            }
        },
        { 
            field: 'categoria', 
            headerName: 'Categoria', 
            valueGetter: ({row}: {row: any}) => row.lancamentoCategorias?.map((lc: any) => lc.categoria.nome).join(', ') || '' 
        }
    ], [locacoes, veiculosLista]);

    // Altura da linha pela célula Descrição, que empilha locatário, veículo e descrição (mesma regra do
    // renderCell): com os três blocos a altura padrão do grid (60 px) deixava o texto vazar para as linhas
    // vizinhas. Até dois blocos cabem na padrão; cada bloco além disso pede mais 24 px.
    const alturaDaLinha = useCallback((row: any) => {
        const locacao = row.idLocacao ? locacoes.find((l) => l.id === row.idLocacao) : null;
        const veiculo = locacao?.veiculo || row.idVeiculo ? veiculosLista.find((v) => v.id == row.idVeiculo) : null;
        const blocos = 1 + (locacao?.locatario ? 1 : 0) + (veiculo ? 1 : 0);
        return 60 + Math.max(0, blocos - 2) * 24;
    }, [locacoes, veiculosLista]);

    return (
        <>
            <LocaSmartLayout>
                <ListagemLancamento
                    buscar={buscar}
                    onBuscar={handleBuscarLancamentos}
                    colunas={colunas}
                    linhas={lancamentosFiltrados}
                    nomeEntidade="Lançamento"
                    nomePropriedade="descricao"
                    carregando={carregando}
                    IconeEntidade={FaFileInvoice}
                    exibirAcoesDeCrud={true}
                    handleEditar={podeEditarLancamento ? handleEditar : undefined}
                    handleCriar={handleCadastrar}
                    ocultarNovo={!usuarioTemPermissao(token, 'lancamento_novo')}
                    handleExclusao={podeExcluirLancamento ? handleExclusao : undefined}
                    handleVisualizacao={handleVisualizacao}
                    handleSelecionarEntidade={setLancamentoSelecionado}
                    filtros={configFiltros}
                    acoesEmLote={ocultarAcoes(acoesEmLote, permissoesDasAcoes)}
                    exportOptions={exportOptions}
                    tituloExportacao="Lancamentos"
                    alturaDaLinha={alturaDaLinha}
                    acoesExtras={ocultarAcoes([{
                        Icone: FaCheckDouble,
                        OnClick: async (lancamento: any) => {
                            if (lancamento.asaasPaymentId) {
                                if(!(await confirm("Este pagamento é gerenciado automaticamente pelo Asaas!\nTem certeza que deseja confirmar manualmente a baixa? Ao fazer isso, não vai baixar a sua Fatura de forma automática, o pagamento voltará enquanto a fatura existir. Caso tenha recebido por dinheiro, ou qualquer outra forma que não seja a fatura, recomendamos marcar como recebido em dinhero direto no Asaas!", { alert: true, waitSeconds: 10, sound: true })))
                                {
                                    return;
                                }
                            }
                            if (lancamento.status == TipoStatusLancamento.Pendente) {
                                atualizarStatusLancamento(
                                    lancamento.id,
                                    TipoStatusLancamento.Resolvido,
                                    filtros
                                );
                            } else {
                                toast.info('Esse lançamento já foi resolvido.');
                            }
                        },
                        Texto: "Resolver Lançamento",
                        Cor: 'green',
                        Tamanho: 'small'
                    },
                    {
                        Icone: FaLink,
                        Texto: 'Obter Link da Fatura',
                        OnClick: async (e) => {
                           await handleObterFatura(e);
                        },
                        Cor: 'gray',
                        Tamanho: 'small'
                    },
                    ...(integradoAsaas ? [{
                        Icone: FaFileInvoice,
                        Texto: 'Lançar no Asaas',
                        OnClick: async (lancamento: any) => {
                            if (lancamento.asaasPaymentId) {
                                toast.info('Este lançamento já está registrado no Asaas.');
                                return;
                            }
                            if (lancamento.tipo !== TipoLancamento.Entrada) {
                                toast.error('Apenas lançamentos de entrada podem ser registrados no Asaas.');
                                return;
                            }
                            if (lancamento.status !== TipoStatusLancamento.Pendente) {
                                toast.error('Apenas lançamentos pendentes podem ser registrados no Asaas.');
                                return;
                            }
                            if (!lancamento.idLocacao) {
                                toast.error('Este lançamento não está vinculado a uma locação. Vincule a uma locação antes de lançar no Asaas.');
                                return;
                            }
                            if (!(await confirm('Deseja registrar este lançamento como cobrança no Asaas?\nUma fatura será gerada para o locatário vinculado.'))) {
                                return;
                            }
                            try {
                                setCarregando(true);
                                await api.post(`/Lancamento/LancarNoAsaas/${lancamento.id}`);
                                toast.success('Lançamento registrado no Asaas com sucesso!');
                                setBuscar(false);
                                setBuscar(true);
                            } catch (error: any) {
                                tratarErro(error);
                            } finally {
                                setCarregando(false);
                            }
                        },
                        Cor: '#1F467E',
                        Tamanho: 'small' as const
                    }] : [])], permissoesDasAcoes)} />

                <ModalForm
                    pages={pages}
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    show={exibirFormModal}
                    carregando={carregando}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    onSave={onSave}
                    isSaving={isSubmiting}
                    planoPremium={!ehPlanoGratuito(token) && !estaEmPeriodoDeTeste(token)}
                    onFileRemoved={(campo: string) => {
                        setArquivoRemovido(true);
                    }}
                    onImageRemoved={(campo: string) => {
                        setImagemRemovida(true);
                    }}
                    ajudinha={
                        {
                            texto: "Registre lançamentos além dos pagamentos de aluguel. Aqui, você pode registrar pagamentos de seguro, rastreadores, prejuízos, recebimentos de seguro, pendências ativas e muito mais",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={lancamentoSelecionado}
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: lancamentoAtualizacao,
                            forcarAtualizacao: lancamentoForcarAtualizacao
                        }
                    }
                    apiConfig={
                        {
                            endpoint: "lancamento",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                />

                <ModalConfirmacaoLote
                    open={showModalLote}
                    onClose={() => setShowModalLote(false)}
                    onConfirm={handleConfirmarLote}
                    dados={dadosLote}
                    titulo={acaoLote === 'baixar' ? "Confirmar Baixa em Lote" : acaoLote === 'cancelar' ? "Confirmar Cancelamento em Lote" : "Confirmar Exclusão em Lote"}
                    tipoAcao={acaoLote}
                    filtros={{
                        dataInicio: filtros.dataInicio,
                        dataFim: filtros.dataFim,
                        status: filtros.status as unknown as StatusPagamento, 
                        idLocacao: filtrosAvancados.idLocacao
                    }}
                    tela="lançamentos"
                />

                <ModalAjusteValorLote
                    open={showModalAjuste}
                    onClose={() => setShowModalAjuste(false)}
                    onConfirm={handleConfirmarAjuste}
                    dados={dadosLote}
                    carregando={carregando}
                    filtros={{
                        dataInicio: filtros.dataInicio,
                        dataFim: filtros.dataFim,
                        status: filtros.status as unknown as StatusPagamento, 
                        idLocacao: filtrosAvancados.idLocacao
                    }}
                />

            </LocaSmartLayout>
        </>
    );
}

export default LancamentoListagem;